export const isGeolocation = (criteriaKey: string) => ['states', 'township', 'town'].includes(criteriaKey);
export const isStates = (criteriaKey: string) => criteriaKey === 'states';
export const isTownship = (criteriaKey: string) => criteriaKey === 'township';
export const isTown = (criteriaKey: string) => criteriaKey === 'town';
export const isMeasurements = (criteriaKey: string) => criteriaKey === 'measurements';
export const isServiceCode = (criteriaKey: string) => ['service_code', 'service_types', 'clients', 'distribution_provider'].includes(criteriaKey);
export const isRangeValue = (criteriaKey: string) => ['weight', 'postal_code_range', 'declared_value'].includes(criteriaKey);
export const isDDUDDP = (criteriaKey: string) => criteriaKey === 'ddu_ddp';
export const isPostalCodeFile = (criteriaKey: string) => criteriaKey === 'postal_code_list';
